import { RugbyUnionIncidentId } from '@collector/sportsapi-client-legacy'

import { FieldClickCoordinatesIncidentConfig } from '../../../configuration'

export const fieldClickCoordinatesIncidentConfig: FieldClickCoordinatesIncidentConfig<RugbyUnionIncidentId> =
  {
    forceCreateIncidentIds: [RugbyUnionIncidentId.Ruck],
    getIncidentToUpdateCoordinates: {
      [RugbyUnionIncidentId.EntryInto22]: (incidents) => {
        const lastEntryInto22IncidentIndex = incidents.findIndex(
          (incident) =>
            incident.incident_id === RugbyUnionIncidentId.EntryInto22,
        )
        if (lastEntryInto22IncidentIndex === -1) return
        const lastEntryInto22Incident = incidents[lastEntryInto22IncidentIndex]
        for (let i = 0; i < lastEntryInto22IncidentIndex; i++) {
          const incident = incidents[i]
          if (
            incident.participant_team_id !==
              lastEntryInto22Incident.participant_team_id ||
            incident.incident_id === RugbyUnionIncidentId.InPossession
          ) {
            return
          }
        }
        return lastEntryInto22Incident
      },
    },
  }
